import React from 'react'

import Hero from '../Components/Hero';
import Projects from '../Components/Projects';
import Cta from '../Components/Cta';


export default function Home() {
  return (
    
    <div className="flex flex-col pt-24 md:pt-48 xl:pt-52 px-4 md:px-8 lg:px-24 xl:px-48 gap-24 md:gap-20 pb-24 w-full overflow-x-hidden">
    <Hero></Hero>
    <Projects></Projects>
    <Cta></Cta>
    </div>
  )
}
